import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { ApplicationFacade, FavoriteTicket } from '@ridango/components';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ScreenOrientationService } from '@ridango/core/lib/services/screenOrientation.service';

@Component({
    selector: 'gl-ticket-details-zone-map',
    templateUrl: './edit-ticket-favorites-modal.component.html',
    styleUrls: ['./edit-ticket-favorites-modal.component.scss']
})
export class EditTicketFavoritesModalComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() favoriteTickets: FavoriteTicket[];
    assetsPath$ = this.applicationFacade.assetsPath$;
    favoriteTicketsList: FavoriteTicket[] = [];
    public currentLanguage = this.translate.currentLang;
    public isInLandscapeMode = this.screenOrientationService.isInLandscapeMode;

    constructor(
        private applicationFacade: ApplicationFacade,
        public translate: TranslateService,
        private modalCtrl: ModalController,
        private screenOrientationService: ScreenOrientationService
    ) {
        super();
    }

    ngOnInit() {
        this.favoriteTicketsList = this.favoriteTickets;
    }

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    openDeleteTicket(ticket: FavoriteTicket) {
        this.favoriteTicketsList = this.favoriteTicketsList.filter((t) => t.productId !== ticket.productId);
    }

    saveFavoriteTickets() {
        const productIds = this.favoriteTickets
            .filter((ticket) => !this.favoriteTicketsList.find((t) => t.productId === ticket.productId))
            .map((t) => t.productId);

        this.modalCtrl.dismiss(productIds, 'save');
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
